export default "__VITE_ASSET__EY2$O02k__"